"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'socialMediaPlan.schedule.date': 'Publish date',
    'socialMediaPlan.schedule.time': 'Time',
    'socialMediaPlan.schedule.summary': 'Post summary',
    'socialMediaPlan.schedule.draftTitle': 'Draft',
    'socialMediaPlan.schedule.draftDesc': 'Save as draft',
    'socialMediaPlan.schedule.reviewTitle': 'Review',
    'socialMediaPlan.schedule.reviewDesc': 'Request review',
    'socialMediaPlan.schedule.scheduledTitle': 'Scheduled',
    'socialMediaPlan.schedule.scheduledDesc': 'Schedule for later',
    'socialMediaPlan.schedule.publishedTitle': 'Published',
    'socialMediaPlan.schedule.publishedDesc': 'Publish now',
};
